type TagProps = {
    tag: any
}

export const Tag = ({ tag }: TagProps) => (
    <li className={'tag'}>
        {tag}
    </li>
)